import { h, render } from 'preact';
import HeaderNav from './header-nav';
import './header.css';
import { shopliftTesting } from 'utils/shoplift-testing';
import debounce from 'utils/debounce';

export default (element, data) => {
  const hypothesisElements = element.querySelectorAll('[data-hypothesis]');
  hypothesisElements.forEach(element => {
    shopliftTesting(element, data, true);
  });

  const desktopSearch = element.querySelector('.desktop-search');
  const desktopSearchBtn = element.querySelector('.desktop-search-btn');
  //accordion functionality
  const accordionBtns = element.querySelectorAll('[data-accordion-button]');
  const headerOverlay = document.querySelector('[data-header-overlay]');
  const backSearchButton = element.querySelector('[data-back-search]');
  const dataMobileNav = element.querySelector('[data-mobile-navigation]');
  const headerMobileSearch = element.querySelector('.header-mobile-search');
  const secondaryMobileNavigation = element.querySelector('[data-simple-mobile-nav]');

  if (secondaryMobileNavigation) {
    let prevScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let prevScrollDirection = '';

    window.addEventListener('scroll', debounce(() => {
      const scrollPossition = window.pageYOffset || document.documentElement.scrollTop;
      const enableScrolling = Math.abs(scrollPossition - prevScrollTop) > 50; // Fix jumping on mobile

      if (!enableScrolling) return;

      if (scrollPossition > prevScrollTop && prevScrollDirection !== 'down') {
        // downscroll code here
        element.classList.add('scroll-down');
        prevScrollDirection = 'down';
      } else if (scrollPossition < prevScrollTop && prevScrollDirection !== 'up') {
        // upscroll code
        element.classList.remove('scroll-down');
        prevScrollDirection = 'up';
      }
      prevScrollTop = scrollPossition <= 0 ? 0 : scrollPossition;
    }, false), 100);
  }

  document.querySelectorAll('.account-link').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault()
      window.location.href = '#rivo';
    });
  });

  function toggleAccordion(e) {
    e.preventDefault();
    const link = e.currentTarget;
    const parent = link.parentNode;
    const content = parent.querySelector('[data-accordion-content]')
    const plus = parent.querySelector('[data-accordion-plus]')
    const minus = parent.querySelector('[data-accordion-minus]')

    if (!content) return;
    const contentClassesToToggle = ['h-0', 'max-h-0', 'overflow-hidden', 'max-h-[1000px]']
    toggleClasses(content, contentClassesToToggle)
    minus.classList.toggle('hidden')
    plus.classList.toggle('hidden')
    link.classList.toggle('open')
  }



  function toggleClasses(content, classesArr) {
    classesArr.forEach(item => {
      content.classList.toggle(item)
    })
  }


  const init = () => {
    const headerPortal = document.getElementById('header-portal');
    const headerNav = document.querySelector('[data-header="nav"]');
    const mobileNavTriggers = element.querySelectorAll('[data-nav-trigger]');
    const mobileNavClose = element.querySelector('[data-nav-trigger-close]');
    const mobileNav = element.querySelector('[data-header="nav"]');

    const openMobileSearch = () => {
      const autocomplete = document.querySelector('.ss__autocomplete--target');

      if (!dataMobileNav.classList.contains('hidden')) {
        dataMobileNav.classList.add('hidden');
        autocomplete.classList.remove('hidden');
        backSearchButton.classList.remove('hidden')
        document.body.style.overflow = 'hidden';
      }
    };

    const closeMobileSearch = () => {
      const autocomplete = document.querySelector('.ss__autocomplete--target');
      if (dataMobileNav.classList.contains('hidden')) {
        dataMobileNav.classList.remove('hidden');
        autocomplete.classList.add('hidden');
        backSearchButton.classList.add('hidden')
        headerMobileSearch.value = '';
      }
    }


    headerMobileSearch?.addEventListener('focus', openMobileSearch)
    backSearchButton?.addEventListener('click', closeMobileSearch)

    accordionBtns && accordionBtns.forEach(btn => btn.addEventListener('click', toggleAccordion));

    headerOverlay.addEventListener('click', () => {
      document.body.style.overflow = 'hidden';
      mobileNav.classList.toggle('hidden')
    })


    desktopSearch.addEventListener('click', () => {
      const dataSearchTrigger = document.querySelector('[data-search-trigger]');
      dataSearchTrigger.click();
      document.dispatchEvent(new CustomEvent('search:open'))
    })

    desktopSearchBtn.addEventListener('click', () => {
      const dataSearchTrigger = document.querySelector('[data-search-trigger]');
      dataSearchTrigger.click();
      document.dispatchEvent(new CustomEvent('search:open'))
    })

    document.addEventListener('keypress', (event) => {
      const target = event.target;
      const { key } = event;
      const enterKeyPressed = key && key === 'Enter';
      if ((target.classList.contains('desktop-search') || target.classList.contains('desktop-search-btn')) && document.hasFocus() && enterKeyPressed) {
        const dataSearchTrigger = document.querySelector('[data-search-trigger]');
        dataSearchTrigger.click();
        document.dispatchEvent(new CustomEvent('search:open'));
      }
    });

    mobileNavClose.addEventListener('click', () => {
      document.body.style.overflow = '';
      mobileNav.classList.toggle('hidden')
    })

    mobileNavTriggers.forEach(element => {
      element.addEventListener('click', () => {
        document.body.style.overflow = 'hidden';
        mobileNav.classList.toggle('hidden');
        closeMobileSearch();
      });
    });
    if (headerPortal) {
      headerPortal.appendChild(element);
    } else {
      element
        .closest('#shopify-section-header')
        .classList.add('sticky', 'top-0', 'z-50');
    }

    render(<HeaderNav {...data} />, headerNav);
  };
  init();
};
